// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AAKa","col":"styles_col__3Gy_x"};